// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.label[data-v-8c8013ec] {\r\n    color: #6d6d6d;\r\n    font-size: 12px;\r\n    font-weight: 500;\r\n    line-height: 15px;\n}\n.label.label-small[data-v-8c8013ec] {\r\n    font-size: 11px;\r\n    line-height: 13px;\n}\n.label.label-large[data-v-8c8013ec] {\r\n    font-size: 14px;\r\n    line-height: 16px;\n}\n.label.label-red[data-v-8c8013ec],\r\n.label.label-error[data-v-8c8013ec] {\r\n    color: #e96760;\n}\r\n", ""]);
// Exports
module.exports = exports;
